// src/themes/neon.js
//
// Tema Neon — estética de plataforma táctica C5i militar.
// Verde fósforo puro, rojos saturados, fondo casi-negro, tipografía monospace.
//
// Este tema prioriza impacto estético sobre ergonomía de turnos largos.
// Ver vue/docs/desing-claude/neon/NEON-DECISIONES-DE-DISEÑO.md para
// trade-offs y limitaciones operativas documentadas.
//
// Diferencia con Tactical: Tactical usa phosphor P1 histórico (L 76 C 0.17)
// pensado para legibilidad sostenida en turnos nocturnos. Neon usa fósforo
// saturado moderno (L 89, C 0.24+) con glow agresivo — fiel al video de
// referencia del cliente pero con mayor fatiga visual.

export default {
  id: 'neon',
  label: 'Neon',
  mapBasemap: 'dark',

  // ========== SISTEMA A — CHROME ==========

  // Identidad — verde neón saturado
  accent:       '#52FF6A',
  accentDim:    '#3BCC52',
  accentSoft:   'rgba(82, 255, 106, 0.18)',
  accentGlow:   'rgba(82, 255, 106, 0.45)',
  accentBright: '#8EFF9D',

  // Fondos — casi-negros con lift anti-halation (#050709, NO #000000)
  bgDeep:     '#050709',
  bgSurface:  '#0A0D11',
  bgOverlay:  '#10141A',
  bgCard:     '#151922',

  // Texto — blanco con tinte frío
  text:      '#F2F4F7',
  textMuted: '#8A94A3',
  textDim:   '#4F5867',

  // Bordes y separadores
  borderDim:    '#15191F',
  borderNormal: '#1F2633',
  borderAccent: '#2C3545',

  // Trail GPS alineado al accent
  trailLine: '#52FF6A',

  // ========== SISTEMA B — override de operativos y status ==========
  // Sobrescriben los defaults del system-b.js compartido: en Neon los
  // rojos son más saturados, el ámbar más brillante y los verdes de
  // success están colapsados con el accent del tema.

  alertSos:     '#FF2D3A',
  alertDanger:  '#FF3545',
  alertWarning: '#FFB400',
  alertSuccess: '#52FF6A',
  alertInfo:    '#4A9EFF',
  alertSosSoft: 'rgba(255, 45, 58, 0.22)',

  statusOnline:  '#52FF6A',
  statusOffline: '#8A94A3',
  statusAlert:   '#FF3545',
  statusIdle:    '#FFB400',

  // Murphy themed — derivado del neón green accent. Solo se aplica si el
  // modo Murphy es 'themed'. En 'neutral' (default) ganan los grises.
  murphyLight: '#8EFF9D',
  murphyMid:   '#52FF6A',
  murphyDeep2: '#2DA440',
  murphyDeep1: '#146020',
  murphyInk:   '#0A1A0E',

  // ========== TOKENS EXTENDIDOS ==========

  // Tipografía monospace (fiel al video del cliente). Si la fuente no
  // está cargada por el proyecto, cae a ui-monospace del sistema.
  fontFamily: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',

  // Transform y spacing: headings en uppercase; body en natural.
  // Mitigación del problema de Tactical original que aplicaba uppercase
  // global y deterioraba la lectura de nombres propios / direcciones.
  labelTransform:     'none',
  labelLetterSpacing: '0.01em',

  // Glows — variables reutilizables. Los valores son box-shadow completos
  // para que cualquier elemento pueda aplicarlos directo.
  glowSos:     '0 0 16px rgba(255, 45, 58, 0.75), 0 0 32px rgba(255, 45, 58, 0.40)',
  glowAlert:   '0 0 12px rgba(255, 53, 69, 0.60)',
  glowSuccess: '0 0 8px rgba(82, 255, 106, 0.45)',
  glowPanel:   '0 0 24px rgba(82, 255, 106, 0.08)',

  // Text-shadows operativos (mantenidos por compatibilidad con consumers
  // de Tactical que leen accentTextShadow / alertTextShadow).
  accentTextShadow: '0 0 8px rgba(82, 255, 106, 0.55)',
  alertTextShadow:  '0 0 10px rgba(255, 53, 69, 0.65)',
  accentBoxShadow:  '0 0 16px rgba(82, 255, 106, 0.35)',
  alertBoxShadow:   '0 0 18px rgba(255, 53, 69, 0.55), inset 0 0 12px rgba(255, 53, 69, 0.15)',

  // Rutas OSRM unificadas con los otros temas
  routeActiveWidth:  4,
  routePreviewWidth: 2.5,

  // Clusters — colorful preserva breakdown operativo en zonas densas.
  clusterMode: 'colorful',

  // ========== Categorías 911 (manual oficial federal CNIE v3.0) ==========
  // Versión neón: máximo contraste y saturación high-key sobre bg oscuro.
  catSeguridad:         '#4A9EFF',  // azul neón eléctrico
  catMedico:            '#3FE07A',  // verde neón vital
  catProteccionCivil:   '#FFD02C',  // ámbar neón
  catServiciosPublicos: '#9B5CFF',  // morado neón
  catAsistencia:        '#FF8A3D',  // naranja saturado
  catOtrosServicios:    '#8A94A3',  // gris frío (excepción intencional no-neón)
  catMalUso:            '#FF4545',  // rojo neón advertencia
}
